import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  dropDown: {
    width: '100%',
    marginTop: '10px !important',
  },
});
